import React from "react";
import "./aboutflexiaccesswithdrawalmodal.scss";
import { Col, Row } from "react-bootstrap";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
import { addCommas, calculateDuration } from "../../helpers/helpers";
import { Link } from "react-router-dom";

const AboutFlexiAccessWithdrawalModal = (props) => {
  const flexiAccess = props.strategies?.find(
    (strategy) => strategy.strategyName === "Flexi-access" // eslint-disable-line
  );
  const durationMapping =
    flexiAccess?.duration === "HalfYearly"
      ? "half year"
      : flexiAccess?.duration === "Monthly"
        ? "month"
        : flexiAccess?.duration === "Quarterly"
          ? "quarter"
          : flexiAccess?.duration === "Annual"
            ? "year"
            : "";
  return (
    <div className="faw-parent">
      <Row className="mb-3">
        <Col>
          <div className="faw-small-close">
            <Link to="">
              <Icons
                iconname="close"
                variant="icon-sixteen-px"
                clickHandler={props.handleCloseButton}
              />
            </Link>
          </div>
        </Col>
      </Row>
      <Row className="faw-title mb-3">
        <Col>
          <div>{props.modalTitle}</div>
        </Col>
      </Row>
      {props.modalTitle === "About your flexi-access fund switch" ? (
        <Row className="faw-sub-title mb-5">
          <Col>
            <div className="mb-3">
              <div className="mb-3">
                Below is an estimated forecast of your flexi-access drawdown
                income.
              </div>{" "}
              <div className="mb-3">
                You will have an estimated value of{" "}
                <span className="faw-text">
                  £
                  {addCommas(
                    Math.trunc(
                      props.strategies.find(
                        (strategy) => strategy.strategyName === "Flexi-access" // eslint-disable-line
                      ).newCurrentValue // eslint-disable-line
                    ) // eslint-disable-line
                  )}
                  .
                  {(
                    props.strategies.find(
                      (strategy) => strategy.strategyName === "Flexi-access" // eslint-disable-line
                    ).newCurrentValue % 1
                  )
                    .toFixed(2)
                    .substring(2)}
                </span>{" "}
                remaining in flexi-access.
              </div>{" "}
              <div className="mb-3">
                You currently receive{" "}
                <span className="faw-text">
                  £
                  {addCommas(
                    Math.trunc(
                      props.strategies.find(
                        (strategy) => strategy.strategyName === "Flexi-access" // eslint-disable-line
                      ).newCurrentIncome // eslint-disable-line
                    ) // eslint-disable-line
                  )}
                  .
                  {(
                    props.strategies.find(
                      (strategy) => strategy.strategyName === "Flexi-access" // eslint-disable-line
                    ).newCurrentIncome % 1
                  )
                    .toFixed(2)
                    .substring(2)}{" "}
                  every {durationMapping},
                </span>{" "}
                you may run out of money in{" "}
                <span className="faw-text">
                  {
                    calculateDuration(
                      flexiAccess?.newCurrentValue,
                      flexiAccess?.newCurrentIncome,
                      flexiAccess?.duration === "Annual"
                        ? 12
                        : flexiAccess?.duration === "HalfYearly"
                          ? 6
                          : flexiAccess?.duration === "Quarterly"
                            ? 3
                            : 1,
                    )?.years
                  }{" "}
                  years
                </span>{" "}
                and{" "}
                <span className="faw-text">
                  {
                    calculateDuration(
                      flexiAccess?.newCurrentValue,
                      flexiAccess?.newCurrentIncome,
                      flexiAccess?.duration === "Annual"
                        ? 12
                        : flexiAccess?.duration === "HalfYearly"
                          ? 6
                          : flexiAccess?.duration === "Quarterly"
                            ? 3
                            : 1,
                    )?.months
                  }{" "}
                  months.
                </span>
              </div>
              <div>You may wish to amend your regular income if needed.</div>
            </div>
          </Col>
        </Row>
      ) : (
        <Row className="faw-sub-title mb-5">
          <Col>
            <div className="mb-3">
              After withdrawing{" "}
              <span className="faw-text">
                £
                {addCommas(
                  Math.trunc(
                    props.strategies.find(
                      (strategy) => strategy.strategyName === "Flexi-access" // eslint-disable-line
                    ).withdrawAmount // eslint-disable-line
                  ) // eslint-disable-line
                )}
                .
                {(
                  props.strategies.find(
                    (strategy) => strategy.strategyName === "Flexi-access" // eslint-disable-line
                  ).withdrawAmount % 1
                )
                  .toFixed(2)
                  .substring(2)}
              </span>{" "}
              you will have an estimated value of{" "}
              <span className="faw-text">
                £
                {addCommas(
                  Math.trunc(
                    props.strategies.find(
                      (strategy) => strategy.strategyName === "Flexi-access" // eslint-disable-line
                    ).newValue // eslint-disable-line
                  ) // eslint-disable-line
                )}
                .
                {(
                  props.strategies.find(
                    (strategy) => strategy.strategyName === "Flexi-access" // eslint-disable-line
                  ).newValue % 1
                )
                  .toFixed(2)
                  .substring(2)}
              </span>{" "}
              remaining in flexi-access.
            </div>
            {parseFloat(flexiAccess?.currentIncome) > 0 ? (
              <div>
                You currently receive{" "}
                <span className="faw-text">
                  £
                  {addCommas(
                    Math.trunc(
                      props.strategies.find(
                        (strategy) => strategy.strategyName === "Flexi-access" // eslint-disable-line
                      ).currentIncome // eslint-disable-line
                    ) // eslint-disable-line
                  )}
                  .
                  {(
                    props.strategies.find(
                      (strategy) => strategy.strategyName === "Flexi-access" // eslint-disable-line
                    ).currentIncome % 1
                  )
                    .toFixed(2)
                    .substring(2)}{" "}
                  every {durationMapping}
                </span>{" "}
                , you may run out of money in{" "}
                <span className="faw-text">
                  {
                    calculateDuration(
                      flexiAccess?.newValue,
                      flexiAccess?.currentIncome,
                      flexiAccess?.duration === "Annual"
                        ? 12
                        : flexiAccess?.duration === "HalfYearly"
                          ? 6
                          : flexiAccess?.duration === "Quarterly"
                            ? 3
                            : 1,
                    )?.years
                  }
                </span>{" "}
                years and{" "}
                <span className="faw-text">
                  {
                    calculateDuration(
                      flexiAccess?.newValue,
                      flexiAccess?.currentIncome,
                      flexiAccess?.duration === "Annual"
                        ? 12
                        : flexiAccess?.duration === "HalfYearly"
                          ? 6
                          : flexiAccess?.duration === "Quarterly"
                            ? 3
                            : 1,
                    )?.months
                  }{" "}
                  months.
                </span>
              </div>
            ) : (
              ""
            )}
          </Col>
        </Row>
      )}
      <Row className="mb-3">
        <Col xl={12} lg={12} md={12}>
          <div className="faw-group-button">
            <span className="faw-cancel-button">
              <Buttons
                name="Cancel"
                className="secondary"
                variantname="icon-sixteen-px"
                handleClick={props.handleCloseButton}
              ></Buttons>
            </span>
            <Buttons
              name="Continue"
              className="primary"
              variantname="icon-sixteen-px"
              handleClick={props.handleContinue}
            ></Buttons>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default AboutFlexiAccessWithdrawalModal;
